/**
 * Tracking — schiebt nutzbare Interaktions-Events ins dataLayer.
 *
 * Lädt selbst KEINE Drittanbieter-Skripte. GA4/Leadinfo/ClickRank werden im
 * GTM-Container (GTM-NKPKHF2L) als Tags konfiguriert und über diese Events
 * bzw. GTM-Trigger gefeuert — consent-gesteuert via CCM19.
 *
 * Erfasste Events:
 *   file_download   — Klick auf Datei-Link (pdf, doc, xls, zip, csv, …)
 *   outbound_click  — Klick auf externen Link
 *   contact_click   — Klick auf mailto:/tel:
 *   <custom>        — beliebiges Element mit data-track-event="name" (+ data-track-label)
 *
 * Der Seiten-Kontext (page_meta) wird serverseitig in <head> gepusht (page.typoscript),
 * damit er beim GTM-Init verfügbar ist.
 */
const DOWNLOAD_RE = /\.(pdf|docx?|xlsx?|pptx?|zip|rar|csv|txt|rtf|odt|ods)(\?|#|$)/i;

function dl() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
}

function label(el) {
    return (el.textContent || el.getAttribute('aria-label') || '').trim().replace(/\s+/g, ' ').slice(0, 100);
}

/**
 * Feuert GA4 generate_lead für alle Confirmation-/Danke-Marker (data-lead-event)
 * innerhalb von `root`. Wiederverwendbar für nachgeladene Inhalte (z. B. das
 * CTA-Modal). Doppel-Feuern verhindert über ein gesetztes data-lead-fired-Flag.
 *
 * @param {ParentNode} root
 */
export function fireLeadEvents(root = document) {
    root.querySelectorAll('[data-lead-event]:not([data-lead-fired])').forEach((node) => {
        node.setAttribute('data-lead-fired', '1');
        dl().push({
            event: 'generate_lead',
            lead_type: node.dataset.leadType || 'form',
            form: node.dataset.leadForm || '',
        });
    });
}

export function initTracking() {
    // Lead-Conversion beim Rendern einer Erfolgs-/Danke-Ansicht.
    // Marker am Confirmation-/Danke-Element: data-lead-event="form" (+ data-lead-type, data-lead-form).
    // Feuert GA4 generate_lead, vereinheitlicht mit Tool-/Newsletter-Leads.
    fireLeadEvents(document);

    document.addEventListener('click', (e) => {
        // Explizite Custom-Events (CTAs etc.)
        const tracked = e.target.closest('[data-track-event]');
        if (tracked) {
            const data = { event: tracked.dataset.trackEvent };
            if (tracked.dataset.trackLabel) data.label = tracked.dataset.trackLabel;
            dl().push(data);
        }

        const a = e.target.closest('a[href]');
        if (!a) return;
        const href = a.getAttribute('href') || '';
        if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

        if (href.startsWith('mailto:')) {
            dl().push({ event: 'contact_click', method: 'email', link_url: href });
            return;
        }
        if (href.startsWith('tel:')) {
            dl().push({ event: 'contact_click', method: 'phone', link_url: href });
            return;
        }

        let host = '';
        try { host = new URL(a.href, window.location.href).hostname; } catch (_err) { /* ignore */ }

        if (DOWNLOAD_RE.test(href) || a.hasAttribute('download')) {
            const ext = (href.split(/[?#]/)[0].split('.').pop() || '').toLowerCase();
            dl().push({ event: 'file_download', link_url: a.href, link_text: label(a), file_extension: ext });
            return;
        }

        if (host && host !== window.location.hostname) {
            dl().push({ event: 'outbound_click', link_url: a.href, link_domain: host, link_text: label(a) });
        }
    });
}
